import { __assign } from "tslib";
import produce from 'immer';
import { ArtboardUtils } from '../../artboard';
import { ItemClass } from '../shared/types';
export function create(partial) {
    if (partial === void 0) { partial = {}; }
    return __assign({ className: ItemClass.Canvas, artboard: ArtboardUtils.create(), children: [], id: '', title: '' }, partial);
}
export function mAddArtboard(mutable, canvasArtboard) {
    mutable.artboard = canvasArtboard;
    return mutable;
}
export var addArtboard = produce(mAddArtboard);
// TODO: Not strict enough. The 'any' type here
// makes it possible to call the function with a non-object
export function isCanvas(data) {
    return (data === null || data === void 0 ? void 0 : data.className) === 'Canvas';
}
